
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[sport]/news/[slug]",
      function () {
        return require("private-next-pages/[sport]/news/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[sport]/news/[slug]"])
      });
    }
  